/**
 * TODO - preamble
 */
import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199

import { VerificationStep, VerificationService } from '../lib/types/types';
import { VerificationSteps, VerificationStepsEnum } from '../lib/types/runtimeTypes';
import { logger } from '../lib/utils/logger/logger';
import { getOverridenComponent } from '../lib/componentOverride/componentOverride';

import { StepStudentPersonalInfoComponent } from './StepStudentPersonalInfo/StepStudentPersonalInfoComponent';
import { StepSeniorPersonalInfoComponent } from './StepSeniorPersonalInfo/StepSeniorPersonalInfoComponent';
import { StepTeacherPersonalInfoComponent } from './StepTeacherPersonalInfo/StepTeacherPersonalInfoComponent';
import { StepCollectMilitaryStatusComponent } from './StepMilitaryPersonalInfo/StepCollectMilitaryStatusComponent';
import { StepActiveMilitaryPersonalInfoComponent } from './StepMilitaryPersonalInfo/StepActiveMilitaryPersonalInfoComponent';
import { StepInactiveMilitaryPersonalInfoComponent } from './StepMilitaryPersonalInfo/StepInactiveMilitaryPersonalInfoComponent';
import { StepFirstResponderPersonalInfoComponent  } from './StepFirstResponderPersonalInfo/StepFirstResponderPersonalInfoComponent';
import { StepMedicalProfessionalPersonalInfoComponent  } from './StepMedicalProfessionalPersonalInfo/StepMedicalProfessionalPersonalInfoComponent';
import { StepEmploymentPersonalInfoComponent } from './StepEmploymentPersonalInfo/StepEmploymentPersonalInfoComponent';
import { StepDocUploadComponent } from './StepDocUpload/StepDocUploadComponent';
import { StepErrorComponent } from './StepErrorComponent';
import { StepSuccessComponent } from './StepSuccess/StepSuccessComponent';
import { StepPendingComponent } from './StepPending/StepPendingComponent';
import { StepSSOComponent } from './StepSSO/StepSSOComponent';

const defaultComponents = {
    StepStudentPersonalInfoComponent,
    StepSeniorPersonalInfoComponent,
    StepTeacherPersonalInfoComponent,
    StepCollectMilitaryStatusComponent,
    StepActiveMilitaryPersonalInfoComponent,
    StepInactiveMilitaryPersonalInfoComponent,
    StepFirstResponderPersonalInfoComponent,
    StepMedicalProfessionalPersonalInfoComponent,
    StepEmploymentPersonalInfoComponent,
    StepSuccessComponent,
    StepDocUploadComponent,
    StepPendingComponent,
    StepSSOComponent,
    StepErrorComponent,
};

const getComponent = (componentName) => {
    logger.info('getComponent', componentName);
    const overriddenComponent = getOverridenComponent(componentName);
    if (overriddenComponent) {
        return overriddenComponent;
    }

    return defaultComponents[componentName];
};

interface Props {
    stepToLoad: VerificationStep;
    verificationService: VerificationService;
}

const LoadStepComponent = ({ stepToLoad, verificationService }: Props) => {
    logger.info(`LoadStepComponent: rendering step: ${stepToLoad}`);
    let Component;

    switch (stepToLoad) {
        case VerificationStepsEnum.collectStudentPersonalInfo:
            Component = getComponent('StepStudentPersonalInfoComponent');
            break;
        case VerificationStepsEnum.collectSeniorPersonalInfo:
            Component = getComponent('StepSeniorPersonalInfoComponent');
            break;
        case VerificationStepsEnum.collectTeacherPersonalInfo:
            Component = getComponent('StepTeacherPersonalInfoComponent');
            break;
        case VerificationStepsEnum.collectMilitaryStatus:
            Component = getComponent('StepCollectMilitaryStatusComponent');
            break;
        case VerificationStepsEnum.collectActiveMilitaryPersonalInfo:
            Component = getComponent('StepActiveMilitaryPersonalInfoComponent');
            break;
        case VerificationStepsEnum.collectInactiveMilitaryPersonalInfo:
            Component = getComponent('StepInactiveMilitaryPersonalInfoComponent');
            break;
        case VerificationStepsEnum.collectFirstResponderPersonalInfo:
            Component = getComponent('StepFirstResponderPersonalInfoComponent');
            break;
        case VerificationStepsEnum.collectMedicalProfessionalPersonalInfo:
            Component = getComponent('StepMedicalProfessionalPersonalInfoComponent');
            break;
        case VerificationStepsEnum.collectEmployeePersonalInfo:
            Component = getComponent('StepEmploymentPersonalInfoComponent');
            break;
        case VerificationStepsEnum.success:
            Component = getComponent('StepSuccessComponent');
            break;
        case VerificationStepsEnum.docUpload:
            Component = getComponent('StepDocUploadComponent');
            break;
        case VerificationStepsEnum.pending:
            Component = getComponent('StepPendingComponent');
            break;
        case VerificationStepsEnum.sso:
            Component = getComponent('StepSSOComponent');
            break;
        // If explicitly trying to render the error component, such as when testing/styling
        case VerificationStepsEnum.error:
            Component = getComponent('StepErrorComponent');
            break;
        default:
            const msg = `Error: Unknown step to render in LoadStepComponent.
                Unable to render step name "${stepToLoad}". Possible steps are [${VerificationSteps.join(', ')}]`;
            logger.error(msg);
            return <StepErrorComponent verificationService={verificationService} errorId={'invalidStep'} />;
    }

    return <Component verificationService={verificationService} />;
};

export { LoadStepComponent };
